import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-playlist-card',
  templateUrl: './playlist-card.component.html',
  styleUrls: ['./playlist-card.component.css']
})
export class PlaylistCardComponent implements OnInit {

  @Input() playlistCardData: any = [];
  @Output() videoSelected: EventEmitter<any> = new EventEmitter<any>();


  constructor(public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    console.log(this.playlistCardData);
  }

  getVideoDisplayTime(duration:any){
    return this.selfLearnService.secondsToTime(duration);
  }

  emitVideoSelectEvent(){
    this.videoSelected.emit(this.playlistCardData);
  }
  constructJsonForStoreVideoProgress(){
    return {
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: this.selfLearnService.getGradeId(),
      subjectId:  localStorage.getItem("selfLearnSelectedPlayName") == 'Recommended' ? this.playlistCardData.subjects[0].subjectId :Number(this.selfLearnService.getSubjectId()),
      chapterId: Number(this.selfLearnService.getChapterId()),
      chapterName:this.selfLearnService.getChapterName(),
      topicId: Number(this.selfLearnService.getTopicId()),
      playlistTypeId: Number(this.selfLearnService.getPlayListId()),
      topicName: localStorage.getItem('selectedTopicName'),
      videoId: Number(this.playlistCardData.videoId),
      videoName: (this.playlistCardData.title),
      isBookmarked:this.playlistCardData.isBookmarked,
     
    };
  }
  bookMarkCurrentVideo(){
    this.playlistCardData.isBookmarked = !this.playlistCardData.isBookmarked;
    let storeVideoProgressPayLoad :any =  this.constructJsonForStoreVideoProgress()
    this.selfLearnService.storeVideoProgress(storeVideoProgressPayLoad).subscribe((resp:any) => {
     
    })
  }

}
